module.exports = __webpack_public_path__ + "img/MapThumb_Coastal.9995d7bc.webp";